// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Xl1N","questions":"styles_questions__2isqH","footer":"styles_footer__1NliJ"};